import { render } from "./licenseDetail.vue?vue&type=template&id=053df047"
import script from "./licenseDetail.vue?vue&type=script&lang=js"
export * from "./licenseDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__